import React from 'react';
import { useFarmStyles } from '../Styles';
import { Card, Typography } from '@mui/material';
import Grid2 from '@mui/material/Grid2';

interface Props {
  text: string;
}

const DeleteInfoCard = ({ text }: Props) => {
  const { classes } = useFarmStyles();
  return (
    <div className={classes.outerContainer}>
      <Grid2 container>
        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <Card elevation={0} className={classes.card}>
            <div>
              <div className={classes.spanContainer}>
                <Typography variant="h6">
                  Are you sure you want to delete {text}
                </Typography>
              </div>
            </div>
          </Card>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default DeleteInfoCard;
